import type { ReactNode } from 'react';

/** Nothing here — said once, with the one thing to do about it when there is one. */
export function EmptyState({
  title,
  children,
  action,
  testId,
}: {
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  testId?: string;
}) {
  return (
    <div className="ui-empty" data-testid={testId}>
      <p className="ui-empty-title">{title}</p>
      {children === undefined ? null : <div className="ui-empty-body">{children}</div>}
      {action === undefined ? null : <div className="ui-empty-action">{action}</div>}
    </div>
  );
}
